import { ArbiterShell } from "@/components/ArbiterShell";
import { CockpitDashboard } from "@/components/cockpit";

/**
 * Cockpit Arbitre — page d'accueil de la "Maison numerique de l'arbitre".
 *
 * Agrege la vue prioritisee des dossiers, les Next Best Actions recommandees
 * par l'IA, l'Instant Insight contextuel et les notifications, tout en
 * conservant la conformite AI Act Art. 12-13 (tracabilite et confiance
 * affichees sur chaque recommandation).
 *
 * Backend : POST/GET sur `/api/v1/arbiter/dashboard/*`
 * (cf. gsf-arbitral-core, Phase 2 MVP Cockpit).
 */
export default function CockpitPage() {
  return (
    <ArbiterShell title="Cockpit arbitre">
      <div className="flex-1 px-4 sm:px-6 py-6 sm:py-8 max-w-6xl mx-auto w-full">
        <CockpitDashboard />
      </div>
    </ArbiterShell>
  );
}
